import SalesPerformanceAnalytics from "../../../../../assets/Courses/datascienceprojects/salesPerformanceAnalytics.webp";
import SupplyChainPerformanceOptimization from "../../../../../assets/Courses/datascienceprojects/supplyChainPerformanceOptimizationQlikSense.webp";
import ComprehensiveFinancialPerformance  from "../../../../../assets/Courses/datascienceprojects/comprehensiveFinancialPerformanceAnalysisTableau.webp";
import AnalyzingJobMarketingData from "../../../../../assets/Courses/datascienceprojects/analyzingJobMarketingDatausingPowerBI.webp";
import ECommerceDataAnalytics from "../../../../../assets/Courses/datascienceprojects/eCommerceDataAnalyticsPowerBI.webp";

import CreditCardDefaultPrediction from "../../../../../assets/Courses/datascienceprojects/creditCardDefaultPrediction.webp";
import BigMartSalesPredictionml from "../../../../../assets/Courses/datascienceprojects/bigMartSalesPredictionML.webp";
import PredictChurnTelecom from "../../../../../assets/Courses/datascienceprojects/predictChurnforaTelecom.webp";
import StockPricePrediction from "../../../../../assets/Courses/datascienceprojects/stockPriceLSTMandRNN.webp";
import ManytoOneLSTM from "../../../../../assets/Courses/datascienceprojects/manytoOneLSTMforSentiment.webp";
import ImageClassificationModel from "../../../../../assets/Courses/datascienceprojects/imageClassificationPyTorch.webp";
import LSTMTextClassification from "../../../../../assets/Courses/datascienceprojects/pyTorchProjecttoBuildaLSTM.webp";
import BuildMultiClassText from "../../../../../assets/Courses/datascienceprojects/buildMultiClassTextClassificationRNNandLSTM.webp";
import MLOpsPipelineDeployonGCP from "../../../../../assets/Courses/datascienceprojects/buildanoptimalEndtoEndMLOpsPipelineandDeployonGCP.webp";
import ModelusingNaiveBayes from "../../../../../assets/Courses/datascienceprojects/buildaMultiClassTextClassificationNaiveBayes.webp";
import ModelPythonusingCNN from "../../../../../assets/Courses/datascienceprojects/buildaMultiClassImagePythonCNN.webp";
import AWSMLOpsProject from "../../../../../assets/Courses/datascienceprojects/aWSMLOpsProjecttoDeploy.webp";
import PlantSpeciesIdentification from "../../../../../assets/Courses/datascienceprojects/buildanImagePlantSpeciesIdentification.webp";

import PySparkETLProject from "../../../../../assets/Courses/datascienceprojects/pySparkETLProjectforRealTimeDataProcessing.webp";
import TalendRealTimeProject from "../../../../../assets/Courses/datascienceprojects/talendRealTimeProjectforETL.webp";
import DatabricksRealTimeStreaming from "../../../../../assets/Courses/datascienceprojects/databricksRealTimeEventHubsandSnowflake.webp";
import SnowflakeAzureProject from "../../../../../assets/Courses/datascienceprojects/snowflakeAzureProjectTwitterfeeddashboard.webp";
import AnalyseYelpDatasetSpark from "../../../../../assets/Courses/datascienceprojects/analyseYelpDatasetwithSparkAzureDatabricks.webp";
import AzureusingSparkSQL from "../../../../../assets/Courses/datascienceprojects/analyseYelpDatasetwithSparkAzureDatabricks.webp";
import HadoopProjectAnalysis from "../../../../../assets/Courses/datascienceprojects/hadoopProjectAnalysisHadoopHive.webp";
import AzureDataFactory from "../../../../../assets/Courses/datascienceprojects/azureDataFactoryandDatabricks.webp";
import AzureStreamAnalytics from "../../../../../assets/Courses/datascienceprojects/azureStreamAnalyticsServiceMonitoring.webp";
import BuildDataPipeline from "../../../../../assets/Courses/datascienceprojects/buildaDataPipelineAzureSparkPool.webp";

import AIPoweredScriptGeneration from "../../../../../assets/Courses/datascienceprojects/buildaDataPipelineAzureSparkPool.webp";
import BuildLangchainStreamlitChatbot from "../../../../../assets/Courses/datascienceprojects/buildaLangchainChatbotEDALLMs.webp";
import AIVideoSummarizationProject from "../../../../../assets/Courses/datascienceprojects/aIVideoSummarizationAWS.webp";
import TransformersRoBERTaXLNetModel from "../../../../../assets/Courses/datascienceprojects/textClassificationRoBERTaandXLNetModel.webp";
import ModelusingAmazonSageMaker from "../../../../../assets/Courses/datascienceprojects/buildaTextAmazonSageMaker.webp";
import PyTorchProjectBuild from "../../../../../assets/Courses/datascienceprojects/pyTorchProjectGANMNISTDataset.webp";
import OpenAIandAWS from "../../../../../assets/Courses/datascienceprojects/buildandDeployTextSQLLLMOpenAIandAWS.webp";
import GateDAMockTest from "../../../../../assets/Courses/datascienceprojects/pyTorchProjectGANMNISTDataset.webp";

const BusinessIntelligenceProjects = [
  {
    category: "DATA SCIENCE",
    learningPath: "Business Intelligence",
    projects: [
  {
    projectId: 1,
    projectTitle: "Sales Performance Analytics using Power BI",
    videoUrl: "67ef842d3a0a4d7a4373d165",
    image: SalesPerformanceAnalytics,
    completion: 0
  },
  {
    projectId: 2,
    projectTitle: "Supply Chain Performance Optimization - Qlik Sense",
    videoUrl: "67ef84e89f0ed016ab3e37da",
    image: SupplyChainPerformanceOptimization,
    completion: 0
  },
  {
    projectId: 3,
    projectTitle: "Comprehensive Financial Performance Analysis - Tableau",
    videoUrl: "67ef85a167e1092b1969d6cd",
    image: ComprehensiveFinancialPerformance,
    completion: 0
  },
  {
    projectId: 4,
    projectTitle: "Analyzing Job Marketing Data using Power BI",
    videoUrl: "67ef85e822d56a5f9fb93099",
    image: AnalyzingJobMarketingData,
    completion: 0
  },
  // {
  //   projectId: 4,
  //   projectTitle: "Smart Shoe Development using ESP32 and Blynk",
  //   videoUrl: "6613a2284443c779482576e3",
  //   image: AnalyzingJobMarketingData,
  // },
  {
    projectId: 5,
    projectTitle: "E-Commerce Data Analytics - Power BI",
    videoUrl: "67ef8690c40f704c14fec74e",
    image:  ECommerceDataAnalytics,
    completion: 0
  },
]
  }
];

const MachineLearningAIProjects = [
  {
    category: "DATA SCIENCE",
    learningPath: "Machine Learning and AI",
    projects: [
    {
      projectId: 1,
      projectTitle: "Credit Card Default Prediction using Machine learning techniques",
      videoUrl: "67ef876aed728b74ba9b2ac8",
      image: CreditCardDefaultPrediction,
      completion: 0
    },
    {
      projectId: 2,
      projectTitle: "BigMart Sales Prediction ML Project in Python",
      videoUrl: "67ef88bb51e03102adfc1977",
      image: BigMartSalesPredictionml,
      completion: 0
    },
    {
      projectId: 3,
      projectTitle: "Predict Churn for a Telecom company using Logistic Regression",
      videoUrl: "67ef899b8ddb917f8d6aa666",
      image: PredictChurnTelecom,
      completion: 0
    },
    {
      projectId: 4,
      projectTitle: "Stock Price Prediction Project using LSTM and RNN",
      videoUrl: "67ef8a4b9f0ed016ab3e3ac4",
      image: StockPricePrediction,
      completion: 0
    },
    {
      projectId: 5,
      projectTitle: "Many-to-One LSTM for Sentiment Analysis and Text Generation",
      videoUrl: "67ef8b2522d56a5f9fb932de",
      image:  ManytoOneLSTM,
      completion: 0
    },
    {
      projectId: 6,
      projectTitle: "Image Classification Model using Transfer Learning in PyTorch",
      videoUrl: "67ef8ba905ff48569549a2e9", 
      image: ImageClassificationModel,
      completion: 0
    },
    {
      projectId: 7,
      projectTitle: "PyTorch Project to Build a LSTM Text Classification Model",
      videoUrl: "67ef975b9f0ed016ab3e423f",
      image: LSTMTextClassification,
      completion: 0
    },
    {
      projectId: 8,
      projectTitle: "Build Multi Class Text Classification Models with RNN and LSTM",
      videoUrl: "67ef98515eb8e02c16fd01b5", 
      image: BuildMultiClassText,
      completion: 0
    },
    {
      projectId: 9,
      projectTitle: "Build an optimal End-to-End MLOps Pipeline and Deploy on GCP",
      videoUrl: "67ef992205ff48569549aa1d", 
      image: MLOpsPipelineDeployonGCP,
      completion: 0
    },
    {
      projectId: 10,
      projectTitle: "Build a Multi ClassText Classification Model using Naive Bayes",
      videoUrl: "67ef9a4a61f2f5184658518b", 
      image: ModelusingNaiveBayes,
      completion: 0
    },
    {
      projectId: 11,
      projectTitle: "Build a Multi Class Image Classification Model Python using CNN",
      videoUrl: "67ef9b11a4fa15777200b6cf", 
      image: ModelPythonusingCNN,
      completion: 0
    },
    {
      projectId: 12,
      projectTitle: "AWS MLOps Project to Deploy Multiple Linear Regression Model",
      videoUrl: "67ef9c4522d56a5f9fb93bff", 
      image: AWSMLOpsProject,
      completion: 0
    },
    {
      projectId: 13,
      projectTitle: "Build an Image Classifier for Plant Species Identification",
      videoUrl: "67ef9d27fecd185d15c29782", 
      image: PlantSpeciesIdentification,
      completion: 0
    },
    ]
  }
  ];

  const DataEngineeringProjects = [
    {
      category: "DATA SCIENCE",
      learningPath: "Data Engineering",
      projects: [
    {
      projectId: 1,
      projectTitle: "PySpark ETL Project for Real-Time Data Processing",
      videoUrl: "67ef9e5822ed09700468de08",
      image: PySparkETLProject,
      completion: 0
    },
    {
      projectId: 2,
      projectTitle: "Talend Real-Time Project for ETL Process Automation",
      videoUrl: "67ef9f3b8ddb917f8d6ab118",
      image: TalendRealTimeProject,
      completion: 0
    },
    {
      projectId: 3,
      projectTitle: "Databricks Real-Time Streaming with Event Hubs and Snowflake",
      videoUrl: "67efa0e405ff48569549adcd",
      image: DatabricksRealTimeStreaming,
      completion: 0
    },
    {
      projectId: 4,
      projectTitle: "Snowflake Azure Project to build real-time Twitter feed dashboard",
      videoUrl: "67efa1880a95874416d9561a",
      image: SnowflakeAzureProject,
      completion: 0
    },
    {
      projectId: 5,
      projectTitle: "Analyse Yelp Dataset with Spark & Parquet Format on Azure Databricks",
      videoUrl: "67efa2205eb8e02c16fd067b",
      image:  AnalyseYelpDatasetSpark,
      completion: 0
    },
    {
      projectId: 6,
      projectTitle: "Build a movie recommender system on Azure using Spark SQL",
      videoUrl: "67efa2c0ed728b74ba9b3937", 
      image: AzureusingSparkSQL,
      completion: 0
    },
    {
      projectId: 7,
      projectTitle: "Hadoop Project-Analysis of Yelp Dataset using Hadoop Hive",
      videoUrl: "67efa3a167729204259e2a20",
      image: HadoopProjectAnalysis,
      completion: 0
    },
    {
      projectId: 8,
      projectTitle: "Azure Data Factory and Databricks End-to-End Project",
      videoUrl: "67efa44e05ff48569549aef8", 
      image: AzureDataFactory,
      completion: 0
    },
    {
      projectId: 9,
      projectTitle: "Azure Stream Analytics for Real-Time Cab Service Monitoring",
      videoUrl: "67efa64f22d56a5f9fb94005", 
      image: AzureStreamAnalytics,
      completion: 0
    },
    {
      projectId: 10,
      projectTitle: "Build a Data Pipeline with Azure Synapse and Spark Pool",
      videoUrl: "67efa6f722d56a5f9fb94036", 
      image: BuildDataPipeline,
      completion: 0
    },
  ]
}
  ];

  const GenerativeAIProjects = [
    {
      category: "DATA SCIENCE",
      learningPath: "Generative AI",
      projects: [
    {
      projectId: 1,
      projectTitle: "AI-Powered Script Generation with Hugging Face and LangChain",
      videoUrl: "67efa7deff2d3e0a346daaa5",
      image: AIPoweredScriptGeneration,
      completion: 0
    },
    {
      projectId: 2,
      projectTitle: "Build a Langchain Streamlit Chatbot for EDA using LLMs",
      videoUrl: "67efa8d6ed728b74ba9b3bbf",
      image: BuildLangchainStreamlitChatbot,
      completion: 0
    },
    {
      projectId: 3,
      projectTitle: "AI Video Summarization Project using Mixtral, Whisper, and AWS",
      videoUrl: "67efa9c251e03102adfc2a9d",
      image: AIVideoSummarizationProject,
      completion: 0
    },
    {
      projectId: 4,
      projectTitle: "Text Classification with Transformers-RoBERTa and XLNet Model",
      videoUrl: "67efaa7756592d11fada7a72",
      image: TransformersRoBERTaXLNetModel,
      completion: 0
    },
    {
      projectId: 5,
      projectTitle: "Build a Text Generator Model using Amazon SageMaker",
      videoUrl: "67efab5cf818f128aa82f81e",
      image:  ModelusingAmazonSageMaker,
      completion: 0
    },
    {
      projectId: 6,
      projectTitle: "PyTorch Project to Build a GAN Model on MNIST Dataset",
      videoUrl: "67efabf705ff48569549b18b", 
      image: PyTorchProjectBuild,
      completion: 0
    },
    {
      projectId: 7,
      projectTitle: "Build and Deploy Text-2-SQL LLM Using OpenAI and AWS",
      videoUrl: "67efacce0a95874416d95bf2",
      image: OpenAIandAWS,
      completion: 0
    },
  ]
}
];

  const CertifiedDataScientistProjects = [
    {
      category: "DATA SCIENCE",
      learningPath: "Certified Data Scientist",
      projects: [
    {
      projectId: 1,
      projectTitle: "Credit Card Default Prediction using Machine learning techniques",
      videoUrl: "67ef876aed728b74ba9b2ac8",
      image: CreditCardDefaultPrediction,
      completion: 0
    },
    {
      projectId: 2,
      projectTitle: "BigMart Sales Prediction ML Project in Python",
      videoUrl: "67ef88bb51e03102adfc1977",
      image: BigMartSalesPredictionml,
      completion: 0
    },
    {
      projectId: 3,
      projectTitle: "Predict Churn for a Telecom company using Logistic Regression",
      videoUrl: "67ef899b8ddb917f8d6aa666",
      image: PredictChurnTelecom,
      completion: 0
    },
    {
      projectId: 4,
      projectTitle: "Stock Price Prediction Project using LSTM and RNN",
      videoUrl: "67ef8a4b9f0ed016ab3e3ac4",
      image: StockPricePrediction,
      completion: 0
    },
    {
      projectId: 5,
      projectTitle: "Many-to-One LSTM for Sentiment Analysis and Text Generation",
      videoUrl: "67ef8b2522d56a5f9fb932de",
      image:  ManytoOneLSTM,
      completion: 0
    },
    {
      projectId: 6,
      projectTitle: "Image Classification Model using Transfer Learning in PyTorch",
      videoUrl: "67ef8ba905ff48569549a2e9", 
      image: ImageClassificationModel,
      completion: 0
    },
    {
      projectId: 7,
      projectTitle: "PyTorch Project to Build a LSTM Text Classification Model",
      videoUrl: "67ef975b9f0ed016ab3e423f",
      image: LSTMTextClassification,
      completion: 0
    },
    {
      projectId: 8,
      projectTitle: "Build Multi Class Text Classification Models with RNN and LSTM",
      videoUrl: "67ef98515eb8e02c16fd01b5", 
      image: BuildMultiClassText,
      completion: 0
    },
    {
      projectId: 9,
      projectTitle: "Build an optimal End-to-End MLOps Pipeline and Deploy on GCP",
      videoUrl: "67ef992205ff48569549aa1d", 
      image: MLOpsPipelineDeployonGCP,
      completion: 0
    },
    {
      projectId: 10,
      projectTitle: "Build a Multi ClassText Classification Model using Naive Bayes",
      videoUrl: "67ef9a4a61f2f5184658518b", 
      image: ModelusingNaiveBayes,
      completion: 0
    },
    {
      projectId: 11,
      projectTitle: "Build a Multi Class Image Classification Model Python using CNN",
      videoUrl: "67ef9b11a4fa15777200b6cf", 
      image: ModelPythonusingCNN,
      completion: 0
    },
    {
      projectId: 12,
      projectTitle: "Build an Image Classifier for Plant Species Identification",
      videoUrl: "67ef9d27fecd185d15c29782", 
      image: PlantSpeciesIdentification,
      completion: 0
    },
    ]
  }
  ];

  const DataScienceArtificialIntelligenceProjects = [
    {
      category: "DATA SCIENCE",
      learningPath: "GATE DA",
      projects: [
    {
      projectId: 1,
      projectTitle: "Gate (DA) Mock Test-1",
      videoUrl: "67efb0ba9f0ed016ab3e4d43",
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 2,
      projectTitle: "Gate (DA) Mock Test-2",
      videoUrl: "67efb0ff8ddb917f8d6aba7b",
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 3,
      projectTitle: "Gate (DA) Mock Test-3",
      videoUrl: "67efb14867e1092b1969ec29",
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 4,
      projectTitle: "Gate (DA) Mock Test-4",
      videoUrl: "67efb193e04dbd3e56c1bb4b",
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 5,
      projectTitle: "Gate (DA) Mock Test-5",
      videoUrl: "67efb1d367729204259e30dc",
      image:  GateDAMockTest,
      completion: 0
    },
    {
      projectId: 6,
      projectTitle: "Gate (DA) Mock Test-6",
      videoUrl: "67efb21a67e1092b1969ec73", 
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 7,
      projectTitle: "Gate (DA) Mock Test-7",
      videoUrl: "67efb260a4fa15777200bfbc",
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 8,
      projectTitle: "Gate (DA) Mock Test-8",
      videoUrl: "67efb2a022d56a5f9fb9467f", 
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 9,
      projectTitle: "Gate (DA) Mock Test-9",
      videoUrl: "67efb2fd05ff48569549b559", 
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 10,
      projectTitle: "Gate (DA) Mock Test-10",
      videoUrl: "67efb3424b76ad5a1c001f0c", 
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 11,
      projectTitle: "Gate (DA) Mock Test-11",
      videoUrl: "67efb38467e1092b1969ecff", 
      image: GateDAMockTest,
      completion: 0
    },
    {
      projectId: 12,
      projectTitle: "Gate (DA) Mock Test-12",
      videoUrl: "67efb3db61f2f51846585e23", 
      image: GateDAMockTest,
      completion: 0
    },
  ]
}
  ];

export { BusinessIntelligenceProjects, MachineLearningAIProjects, DataEngineeringProjects, 
  GenerativeAIProjects, CertifiedDataScientistProjects, DataScienceArtificialIntelligenceProjects  };